import { IMedia } from "@/interfaces";
import { formatFileType } from "@/utils/formattingFunctions";
import { Card, CardContent, CardMedia, Typography, Box, Modal } from "@mui/material";
import { ShowButton } from "@refinedev/mui";
import { useModal } from "@refinedev/core";

export const MediaCard = ({
    id,
    filename,
    cdn_url,    
    type,
    enabledActions
}: Partial<IMedia> & {
    enabledActions: Record<"archive" | "view", boolean>
}) => {
    const { show, visible, close } = useModal();

    const handleOpen = (e: React.MouseEvent) => {
        e.stopPropagation();
        show();
    };

    return (
        <>
            <Card
                sx={{
                    position: 'relative',
                    maxWidth: 345,
                    height: '100%',
                    '&:hover .show-button': {
                        opacity: 1
                    }
                }}
            >
                <Box sx={{ position: 'relative' }}>
                    {enabledActions.view && (
                        <ShowButton
                            recordItemId={id}
                            className="show-button"
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: 'white',
                                opacity: 0,
                                transition: 'opacity 0.2s',
                                zIndex: 1
                            }}
                            onClick={handleOpen}
                        />
                    )}
                    <CardMedia
                        component={formatFileType(type || "")}
                        height="200"
                        src={cdn_url}
                        alt={filename}
                        sx={{ objectFit: 'contain' }}
                        controls
                        controlsList="nodownload noremoteplayback nofullscreen"
                    />
                </Box>
                <CardContent>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {filename}
                    </Typography>
                </CardContent>
            </Card>

            <Modal
                open={visible}
                onClose={close}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                slotProps={{
                    backdrop: {
                        onClick: (e) => {
                            e.stopPropagation();
                            close();
                        }
                    }
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        outline: 'none',
                        bgcolor: 'background.paper',
                        p: 1,
                        borderRadius: 1
                    }}
                >
                    <CardMedia
                        component={formatFileType(type || "")}
                        src={cdn_url}
                        alt={filename}
                        controls
                        controlsList="nodownload noremoteplayback nofullscreen"
                        sx={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '85vh', height: '85vh', width: '50vw' }}
                    />
                    <Typography
                        variant="subtitle1"
                        sx={{
                            textAlign: 'center',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {filename}
                    </Typography>
                </Box>
            </Modal>
        </>
    );
};

